import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { SupportComponent } from '@lib/components/support-class';
import { StaticMsgPipe } from '@lib/pipes';
import { CommonLibService } from '@lib/services';
import { MealApplicationSelectModalDisplayDataBase } from '../meal-application-select-modal.state';
import { MealType } from '@common/interfaces';

@Component({
  selector: 'asw-meal-application-decline',
  templateUrl: './meal-application-decline.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MealApplicationDeclineComponent extends SupportComponent {
  constructor(
    private _common: CommonLibService,
    private _staticMsg: StaticMsgPipe,
    public change: ChangeDetectorRef,
    private _staticMsgPipe: StaticMsgPipe
  ) {
    super(_common);
  }

  reload(): void {}
  init(): void {}
  destroy(): void {}

  @Output()
  public applyItem = new EventEmitter<MealApplicationSelectModalDisplayDataBase>();

  /**
   * 選択時の処理
   */
  clickItem() {
    const item: MealApplicationSelectModalDisplayDataBase = {
      key: '',
      type: MealType.NOTMEAL,
      code: 'NTML',
      disp: this._staticMsgPipe.transform('label.declineMealOption'),
      total: 0,
    };
    this.applyItem.emit(item);
  }
}
